import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { SolutionSpecs } from '../components/SolutionSpecs.js';

const SolutionSpecsContainer = ({ type , volume  })=>{
    const { getLabel , locale  } = useIntl();
    const labels = React.useMemo(()=>({
            unit: getLabel('products.unit.metric.liter.milli.abbr')
        })
    , [
        locale,
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(SolutionSpecs, {
        labels: labels,
        type: type,
        volume: volume
    });
};

export { SolutionSpecsContainer };
//# sourceMappingURL=SolutionSpecsContainer.js.map
